import { httpClient } from "./httpClient";

const postContactUs = (data) => {
  return httpClient.post(`/contact-us`, data);
};

export default {
  postContactUs,
};
